import React from "react";
import {Box, HorizontalLine, Radio, Stack} from "@mbank-design/design-system/components";
import {ParticipationType} from "../../../model/ParticipationType";
import {AllowedParticipationType} from "../../../model/SpeakerInvitationCreateMessage";

export interface ParticipationProps {
    participationType: ParticipationType | undefined;
    allowedParticipationType: AllowedParticipationType;
    onParticipationTypeChange: ((participationType: ParticipationType) => void);
}

export default function Participation({
                                          participationType,
                                          allowedParticipationType,
                                          onParticipationTypeChange
                                      }: ParticipationProps) {

    if (!participationType)
        return (<></>);

    const shouldDisplayOnSite: boolean = allowedParticipationType === AllowedParticipationType.OnSite
        || allowedParticipationType === AllowedParticipationType.Hybrid;
    const shouldDisplayRemote: boolean = allowedParticipationType == AllowedParticipationType.Remote
        || allowedParticipationType === AllowedParticipationType.Hybrid;

    return (
        <Stack>
            <HorizontalLine/>
            <Box marginBottom={16}>
                <Stack direction={["column", "row"]}>
                    {shouldDisplayOnSite && <Radio checked={participationType === ParticipationType.OnSite}
                                                   onChange={() => onParticipationTypeChange(ParticipationType.OnSite)}>in person</Radio>}
                    {shouldDisplayRemote && <Radio checked={participationType === ParticipationType.Remote}
                                                   onChange={() => onParticipationTypeChange(ParticipationType.Remote)}>virtually</Radio>}
                    <Radio checked={participationType === ParticipationType.NotParticipate}
                           onChange={() => onParticipationTypeChange(ParticipationType.NotParticipate)}>skip</Radio>
                </Stack>
            </Box>
        </Stack>
    );
}